import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { FC } from 'react';
import { AlertCircle } from 'react-ionicons';

interface UploadErrorProps {
  onClear: () => void;
}

const UploadError: FC<UploadErrorProps> = ({ onClear }) => {
  return (
    <>
      <span className="text-status-error-default">
        <AlertCircle width="64px" height="64px" color="currentColor" />
      </span>
      <p className="mb-4 mt-2 text-[20px] font-bold leading-7 text-content-base-default">
        The file to upload must be in CSV, Excel, PDF, PNG or TXT format.
      </p>
      <GraniteButton size="small" variant="secondary" onClick={onClear}>
        Try again
      </GraniteButton>
    </>
  );
};

export default UploadError;
